<template>
  <!-- threeSolidHome   地图概览 -->
  <div class="threeSolidHome">
    <div class="my-map-box">
      <MyMap ref="myMapRef" />
    </div>
    <div class="test-map">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        @click="handleClick(item)"
        class="btn"
        :class="typeListactive === item.id ? 'active' : ''"
      >
        {{ item.title }}
      </div>
    </div>
    <search
      v-model:equipemntType="mapNameLabel"
      v-model:searchType="typeListactive"
      :close="!frameOpenClose"
      @emitLocation="mapArea"
      @emitRegionList="getRegionList"
    ></search>
    <div class="home-content">
      <threeSolidLeft></threeSolidLeft>
      <threeSolidRight v-model:frameStatus="frameOpenClose"></threeSolidRight>
    </div>
    <mapRemindArea
      id="showPointDom"
      ref="showPointRef"
      v-show="showPointDom"
      :pointInfo="mapPointData"
      @closeReminder="closePointDom"
    ></mapRemindArea>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  nextTick,
  provide,
  readonly,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import MyMap from "@/components/map/MyMap.vue";

import threeSolidLeft from "./components/threeSolidLeft";
import threeSolidRight from "./components/threeSolidRight";
import mapRemindArea from "./components/mapRemindArea";
import { leftListquery } from "@/api/threeSolid/fileManagement.js";
import { patrolmanInfo } from "@/api/system/patrol";
import { regionSelectids } from "@/api/system/region.js";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
import { ElMessage } from "element-plus";
export default defineComponent({
  name: "",
  components: {
    MyMap,
    threeSolidLeft,
    threeSolidRight,
    mapRemindArea,
  },
  props: {},
  setup(props) {
    const { reversePoint } = handleCoordinates();
    const myMapRef = ref(null);
    const showPointRef = ref(null);
    const data = reactive({
      mapNameLabel: "区域信息",
      frameOpenClose: true,
      showPointDom: false,
      mapPointData: null,

      typeListactive: 0,
      currentRegionId: 0,
    });
    const refData = toRefs(data);
    const regionInfo = reactive({
      regionList: [],
    });
    provide("region", regionInfo);
    const name = ref("1");
    provide("areaData", name);
    const getRegionList = (val) => {
      regionInfo.regionList = val;
      getAreaAccord(val); //地图放区域面积
    };
    const mapArea = (val) => {
      if (data.mapNameLabel == "区域信息") {
        name.value = val.regionId;
        if (val.regionId == "1") return;
        data.currentRegionId = val.regionId;
        leftListqueryAxiois([val]);
      } else if (data.mapNameLabel == "巡防信息") {
        patrolListAxios(val);
      }
    };

    //展示点位详情
    const handleMapPointClick = (e) => {
      data.showPointDom = true;
      const dom = document.getElementById("showPointDom");
      let pos = e[0].values_.location;
      let drawOption = {
        positioning: "bottom-center",
        offset: [0, -40],
        stopEvent: false,
      };
      myMapRef.value && myMapRef.value.drawPointInfo(dom, pos, drawOption);
    };
    //清空地图信息
    const clearMapDraw = () => {
      myMapRef.value && myMapRef.value.clearArea();
      myMapRef.value && myMapRef.value.clearPoint();
      closePointDom();
    };
    //关闭多个点位详情
    const closePointDom = () => {
      data.showPointDom = false;
    };

    const getAreaAccord = async (val) => {
      console.log(val);
      if (val.length == 0) {
        myMapRef.value && myMapRef.value.clearArea();
        myMapRef.value && myMapRef.value.clearPoint();
        return;
      }
      const params = {
        ids: val,
      };
      const res = await regionSelectids(params);
      if (res.code == 0) {
        drawAreaByCoord(res.data);
      }
    };
    //画区域
    const drawAreaByCoord = async (valueArr) => {
      myMapRef.value && myMapRef.value.clearArea();
      myMapRef.value && myMapRef.value.clearPoint();
      setTimeout(() => {
        valueArr.forEach((value) => {
          if (!value) return;
          const arr = [];
          if (
            !value.longitude ||
            !value.latitude ||
            value.coord == null ||
            value.coord == "[]"
          ) {
            ElMessage.warning("暂无小区区域信息");
            return;
          }
          JSON.parse(value.coord).forEach((items) => {
            items = items.map((element) => {
              return reversePoint(element);
            });
            arr.push(items);
          });
          myMapRef.value &&
            myMapRef.value.drawArea(arr, "rgba( 255, 0, 0, 0.2)");
          const pointInfo = {
            name: value.name,
            item: value,
            id: value.regionId,
            type: 1,
            // poiType: typeValue,
            showType: 3,
            location: [value.longitude, value.latitude],
            click: (e) => {
              handleMapPointClick(e);
              nextTick(() => {
                data.mapPointData = value;
              });
            },
          };
          nextTick(() => {
            myMapRef.value &&
              myMapRef.value.mapLocation(pointInfo.location, 14);
            myMapRef.value && myMapRef.value.loadMarker([pointInfo]);
          });
        });
      }, 200);
    };

    return {
      ...refData,
      myMapRef,
      showPointRef,
      mapArea,
      handleMapPointClick,
      closePointDom,
      getRegionList,
    };
  },
});
</script>
<style lang="scss" scoped>
.threeSolidHome {
  height: 100%;
  width: 100%;
  position: relative;
  .my-map-box {
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
  .test-map {
    position: absolute;
    bottom: 2%;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    color: #fff;
    z-index: 10;
    button {
      border: none;
    }
    .btn {
      cursor: pointer;
      position: relative;
      bottom: 0px;
      color: #fff;
      width: 140px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      background-color: rgba(255, 255, 255, 0);
      background-image: url("~@/assets/images/0303/menu2.png");
      background-repeat: no-repeat;
      margin: 0 5px;
      &.active {
        color: #fff;
        width: 140px;
        height: 50px;
        background-color: rgba(255, 255, 255, 0);
        background-image: url("~@/assets/images/0303/menu1.png");
        background-repeat: no-repeat;
      }
    }
  }
  .home-content {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    pointer-events: none;
    display: flex;

    .home-left {
      pointer-events: auto;
    }
  }
}
</style>
